export const iconFontAwesomeBuildingsCity = (
	<i className="fa-solid fa-city"></i>
);
